import { FILTER_TYPE } from 'components/FiltersBlock/types';

import {
  BOOLEAN_SELECT,
  IS_CRITICAL,
  IS_FINAL,
  MONTHS,
  PLACEMENT_KIND,
  YEARS,
} from 'consts/filtersValue';

export const YEAR_FILTER = {
  label: 'Год',
  name: 'year',
  type: FILTER_TYPE.SELECT,
  customOptions: YEARS,
};

export const MONTH_FILTER = {
  label: 'Месяц',
  name: 'month',
  type: FILTER_TYPE.SELECT,
  customOptions: MONTHS,
};

export const PLACEMENT_KIND_FILTER = {
  label: 'Тип помещения',
  name: 'placement_kind',
  type: FILTER_TYPE.SELECT,
  customOptions: PLACEMENT_KIND,
};

export const READY_FOR_CALL_FILTER = {
  label: 'Готово к вызову',
  name: 'is_ready',
  type: FILTER_TYPE.SELECT,
  customOptions: BOOLEAN_SELECT,
};

export const FURNITURE_INSTALLED_FILTER = {
  label: 'Мебель установлена',
  name: 'is_furniture_installed',
  type: FILTER_TYPE.SELECT,
  customOptions: BOOLEAN_SELECT,
};

export const PLAN_LOADED_FILTER = {
  label: 'Наличие плана',
  name: 'is_plan_loaded',
  type: FILTER_TYPE.SELECT,
  customOptions: BOOLEAN_SELECT,
};

export const IS_FINAL_FILTER = {
  label: 'Тип проверки',
  name: 'is_final',
  type: FILTER_TYPE.SELECT,
  customOptions: IS_FINAL,
};

export const IS_CRITICAL_FILTER = {
  label: 'Критичность дефекта',
  name: 'is_critical',
  type: FILTER_TYPE.SELECT,
  customOptions: IS_CRITICAL,
};

export const HAVING_PLAN_FILTER = {
  label: 'Наличие плана',
  name: 'has_settlement_plan',
  type: FILTER_TYPE.SELECT,
  customOptions: BOOLEAN_SELECT,
};
